import React, { useState, useRef, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Button, Input } from "reactstrap";
import { connect } from "react-redux";

import styles from "./SliderPositionInput.module.css";
import { updateSliderPosition } from "../../actions/sliderAction";

const SliderPositionInput = ({ slider, save, onRefresh }) => {
  const sliderId = slider.id;
  const [isEditing, setIsEditing] = useState({ [sliderId]: false });
  const [sliderOrder, setSliderOrder] = useState({ [sliderId]: slider.order });
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsEditing(prev => ({ ...prev, [sliderId]: false }));
        setSliderOrder(prev => ({ ...prev, [sliderId]: slider.order }));
      }
    };

    if (isEditing[sliderId]) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [sliderId, slider.order, isEditing]);

  const handleSave = useCallback(async () => {
    try {
      const payload = {
        id: sliderId,
        category_id: slider.category_id,
        name: slider.name,
        type: slider.type,
        active: slider.active,
        img_url: slider.img_url,
        redirect_url: slider.redirect_url,
        order: Number(sliderOrder[sliderId]),
        data: slider.data,
        tags: slider.tags,
        platform: slider.platform,
        started_at: slider.started_at,
        ended_at: slider.ended_at,
      }
      
      setIsEditing(prev => ({ ...prev, [sliderId]: false }));
      await save(payload);
      onRefresh({ preventDefault: () => {} });
    } catch (error) {
      console.error('Error saving slider:', error);
      alert('Error saving slider');
    }
  }, [save, sliderId, sliderOrder, slider, onRefresh]);

  return (
    <div className={styles.sliderPositionInput}>
      Slider Position:{" "}
      {!isEditing[sliderId] ? (
        <span
          onClick={() => setIsEditing({ [sliderId]: !isEditing[sliderId] })}
        >
          {sliderOrder[sliderId]}
        </span>
      ) : (
        <div ref={wrapperRef} className={styles.sliderPositionInputForm}>
          <Input
            type="number"
            value={sliderOrder[sliderId]}
            onChange={(e) => {
              setSliderOrder({ [sliderId]: e.target.value });
            }}
          />
          <Button
            size="sm"
            onClick={handleSave}
          >
            <i className="fa fa-check"></i>
          </Button>
          <Button
            size="sm"
            onClick={() => {
              setIsEditing({ [sliderId]: false });
              setSliderOrder({ [sliderId]: slider.order });
            }}
          >
            <i className="fa fa-close"></i>
          </Button>
        </div>
      )}
    </div>
  );
};

SliderPositionInput.propTypes = {
  slider: PropTypes.object.isRequired,
  onRefresh: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  save:(payload) => dispatch(updateSliderPosition(payload)),
});

export default connect(null, mapDispatchToProps)(SliderPositionInput);
